import * as actionTypes from '../actions/actionTypes';

const initialState = {
    loading: true,
    uploaded:false,
    uploadStart:false,
    files: [],
};

const uploadDocsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.Add_FILE:
            return {
                ...state,
                files: state.files.concat({file: action.file, doc_name: action.doc_name}),
            };
        case actionTypes.REMOVE_FILE:
            console.log('##action.filename: '+ JSON.stringify(action.filename))
            return {
                ...state,
                files: state.files.filter((data, index) => data.file.name !== action.filename.name),
            };
        case actionTypes.UPLOAD_FILE_SUCCESS:
            return{
                ...state,
                uploaded:true,
                uploadStart:false,
            }
        case actionTypes.SET_FALSE_UPLOADED_FILE_SUCCESS:
            return{
                ...state,
                uploaded:false,
                uploadStart:false,
            }
        case actionTypes.UPLOAD_FILE_START:
            return{
                ...state,
                uploadStart:true,
            }
        default:
            return state;
    }
};

export default uploadDocsReducer;